import React, { useContext, useEffect, useState, useRef, useMemo, useCallback } from "react";
import { Button, Modal } from "antd";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import { useTranslation } from "react-i18next";
import logger from "@/utils/logger";
import { CloseCircleOutlined } from "@/utils/antdIcon";
import EventBus from "@/utils/bus";
import { isFocusEnv, getLoginURL } from "@/utils";
import { connect } from "dvajs";

function ExitTipModal({ setShowLogoutModal }: { setShowLogoutModal: Function }) {
  const globalContext = useContext<GlobalContextConfig>(GlobalContext);
  const { focusSDK } = globalContext;
  const { t } = useTranslation("common");
  const [visible, setVisible] = useState(false);
  const [msgText, setMsgText] = useState("");
  const accountTip = useMemo(() => {
    if (msgText) {
      return msgText;
    }
    return t("account-off-line-tips");
  }, [t, msgText]);
  const confirm = () => {
    setTimeout(() => {
      // tj: 延迟退出，解决页面卡死
      focusSDK.printLog("ExitTipModal", "--------");
      if (!isFocusEnv()) {
        focusSDK.emit("logout");
      } else {
        focusSDK.logout();
      }
    }, 100);
  };
  const forceQuitListener = useCallback(
    (msg: any) => {
      console.log("forceQuitListener");
      const { code, msgtext } = msg;
      const nodes = document.querySelectorAll(".ant-modal-root");
      // tj: 打开名片时，互踢假死
      if (nodes && nodes.length > 0) {
        nodes.forEach((node) => {
          node.setAttribute("style", "display:none");
        });
      }
      EventBus.emit("app:toggle-user-card-modal:hide", {});
      focusSDK.printLog("logout setVisible true");
      // 退出之后再弹出对话框
      let text = "";
      if (msgtext) {
        text = msgtext;
      } else {
        text = t("account-off-line-tips");
      }
      // setShowLogoutModal(text);
      setMsgText(text);
      setVisible(true);
      // 网页端展示弹窗
      //   if (!isFocusEnv()) {
      //     setVisible(true);
      //   } else {
      //     // if (!isFocusEnv()) {
      //     //   focusSDK.emit("logout");
      //     // } else {
      //     focusSDK.logout();
      //     // }
      //   }
      //   if (!isFocusEnv()) {
      //     focusSDK.clearCookies();
      //   }
    },

    // eslint-disable-next-line react-hooks/exhaustive-deps
    [setShowLogoutModal]
  );

  useEffect(() => {
    EventBus.off("chat:force_quit", forceQuitListener).on("chat:force_quit", forceQuitListener);
    return () => {
      EventBus.off("chat:force_quit", forceQuitListener);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Modal
      title={
        <div style={{ display: "flex", alignItems: "center" }}>
          <CloseCircleOutlined style={{ fontSize: "18px", color: "red", marginRight: "10px" }} />
          <div>{t("account-off-line")}</div>
        </div>
      }
      width={450}
      closable={false}
      visible={visible}
      maskClosable={true}
      keyboard={true}
      okText={t("button.ok")}
      footer={
        <Button type="primary" onClick={confirm}>
          {t("button.ok")}
        </Button>
      }
      zIndex={2000}
    >
      <p>{accountTip}</p>
    </Modal>
  );
}
function mapStateToProps({ user }: any) {
  return {};
}

function mapDispatchToProps(dispatch: any) {
  return {
    setShowLogoutModal: (data: any) => {
      dispatch({ type: "user/setShowLogoutModal", payload: data });
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ExitTipModal);
